// extracted by mini-css-extract-plugin
module.exports = {"view-profile-btn":"StudentProfileBox_view-profile-btn__2we3D","student-profile-row":"StudentProfileBox_student-profile-row__3xj4a"};